import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PanelRoot } from '@iptv/ui';
import { App } from './App.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PanelRoot audience="merchant">
      <App />
    </PanelRoot>
  </StrictMode>,
);
